module.exports = __webpack_public_path__ + "img/santa.84e0f358.png";